module.exports = __webpack_public_path__ + "img/44.de318897.png";